import {selectedBuilding, withBuildingScope} from './building-scope';

/** Router history may supply a return hint; it cannot change scope or leave staff routes. */
export function searchReturnPath(value: unknown, building: string | undefined, defaultHome = '/') {
  const fallback = building ? withBuildingScope(`/buildings/${building}`, building) : defaultHome;
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return fallback;
  const url = new URL(value, 'https://staff.invalid');
  if (url.origin !== 'https://staff.invalid' || /^\/(search|portal|procurement\/respond)(\/|$)/.test(url.pathname)) return fallback;
  const own = selectedBuilding(url.pathname, url.search) ?? url.searchParams.get('developmentId');
  if (!building && own) return fallback;
  if (building && own && own !== building) return fallback;
  if (building && ['building', 'developmentId'].some(key => url.searchParams.getAll(key).some(id => id !== building))) return fallback;
  return withBuildingScope(`${url.pathname}${url.search}${url.hash}`, building);
}
